import { render, staticRenderFns } from "./MollierDiagramComponent.vue?vue&type=template&id=12db5b4e&"
import script from "./MollierDiagramComponent.vue?vue&type=script&lang=js&"
export * from "./MollierDiagramComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports